import React from 'react';
import { Button } from '@ui-propulsion/react-components';
import classNames from 'classnames';
import dayJs from 'dayjs';

const Card = ({ cardLogoClassName, children }) =>
  <div className='card-container'>
    <div className='card-logo'>
      <div className={classNames('card-logo-symbol', cardLogoClassName)} />
    </div>
    <div className='card-body'>{children}</div>
  </div>;

const ThankYou = (props) => {
  const {
    signeeFirstName,
    signeeLastName,
    signeeTitle
  } = props.practice;

  const { location } = props;

  const onClick = () => {
    const { origin, pathname } = window.location;

    const newPage = window.open(`${origin}${pathname}?mode=print`, '_blank');
    setTimeout(newPage.print(), 500);
  };

  const thanksSectionClasses = classNames('header-section thanks-section', {
    'thanks-section--print': location.search && /\?mode\=print/.test(location.search)
  });

  return (
    <section className={thanksSectionClasses}>
      <div className='onboarding-complete' />
      <h1 data-test-id="thank-you-notice" className='section-title'>
        Thank you for enrolling with LendingClub Patient Solutions!
      </h1>
      <Card cardLogoClassName='card-signee'>
        <div>
          {`Your agreement was signed on ${dayJs().format('MM/DD/YYYY')} by ${signeeFirstName} ${signeeLastName}, ${signeeTitle}.`}
        </div>
      </Card>
      <Card cardLogoClassName='card-verification'>
        <div>
          We&rsquo;ve received your signed agreement and are in the process of verifying your information.
        </div>
      </Card>
      <Card cardLogoClassName='card-email'>
        <div>
          You&rsquo;ll get an email from us within 1-2 business days, after we have completed the verification process.
        </div>
      </Card>
      <div className='print-action-area'>
        <Button
          data-test-id="print-page-button"
          className='print-btn'
          onClick={onClick}
        >
          Print This Page
        </Button>
      </div>
      <div className='contact-area'>
        <span>
          Have questions? Give us a call at <a href='tel:+18006301663'>(800) 630-1663.</a>
        </span>
      </div>
    </section>
  );
};

export default ThankYou;

